// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1767":"956b6a9ab27c5897","2659":"c2a95d95daa9dbc2","7319":"d0a000f52c75343b","8641":"5ab6778f0bbb8ce7","9509":"2e0919a203bbe1d7"}[chunkId] + ".js";
};